// Belt progression, verbatim from v1 js/constants.js:331-341. Belts are
// per-run (score within a single run), promoting live during play.

export interface Belt {
  minScore: number;
  color: number;
  name: string;
}

export const BELT_PROGRESSION: readonly Belt[] = [
  { minScore: 0, color: 0xffffff, name: 'White' },
  { minScore: 100, color: 0xff0000, name: 'Red' },
  { minScore: 200, color: 0xffff00, name: 'Yellow' },
  { minScore: 300, color: 0xff8c00, name: 'Orange' },
  { minScore: 600, color: 0x00ff00, name: 'Green' },
  { minScore: 1000, color: 0x0000ff, name: 'Blue' },
  { minScore: 1500, color: 0x8b00ff, name: 'Purple' },
  { minScore: 2200, color: 0x8b4513, name: 'Brown' },
  { minScore: 3300, color: 0x000000, name: 'Black' },
];

export function beltIndexForScore(score: number): number {
  let index = 0;
  for (let i = 0; i < BELT_PROGRESSION.length; i++) {
    if (score >= (BELT_PROGRESSION[i] as Belt).minScore) index = i;
  }
  return index;
}

export function beltAt(index: number): Belt {
  return BELT_PROGRESSION[Math.min(index, BELT_PROGRESSION.length - 1)] as Belt;
}
